/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const collectionRefSchema = z.object({
  id: z.number(),
  title: z.string(),
  parent: z.object({ id: z.number(), title: z.string() }).nullable(),
});

export const reviewerReviewedClipSchema = z.object({
  id: z.number(),
  clipId: z.number(),
  action: z.string(),
  rejectionReason: z.string().nullable(),
  decisionMs: z.number().nullable(),
  createdAt: z.number(),
  clipDurationMs: z.number().nullable(),
  clipTranscript: z.string().nullable(),
  clipVerticalPath: z.string().nullable(),
  clipBasePath: z.string().nullable(),
  clipBaseLocalPath: z.string().nullable(),
  clipVerticalLocalPath: z.string().nullable(),
  clipVaultPath: z.string().nullable(),
  challenge: z.object({ id: z.number(), title: z.string() }).nullable(),
  collection: collectionRefSchema.nullable(),
});

export const listReviewerReviewedClipsV1DataSchema = z.object({
  userId: z.string(),
  action: z.string(),
  rows: z.array(reviewerReviewedClipSchema),
  total: z.number(),
});

export type IReviewerReviewedClip = z.infer<typeof reviewerReviewedClipSchema>;
export type IListReviewerReviewedClipsV1Data = z.infer<
  typeof listReviewerReviewedClipsV1DataSchema
>;

export const listReviewerReviewedClipsV1ResponseSchema = createApiResponseSchema(
  listReviewerReviewedClipsV1DataSchema,
) as z.ZodSchema<IAPI<IListReviewerReviewedClipsV1Data>>;

export type IListReviewerReviewedClipsV1Response = IAPI<IListReviewerReviewedClipsV1Data>;
